module.exports = __webpack_public_path__ + "static/media/icon-daily-chest-white.5b601060.svg";